<template lang="pug">
 
  v-dialog(v-model='Entradas.massiveDialog' width='500')
    template(v-slot:activator='{ on }')
      v-btn.d-none.d-md-flex(text v-on='on') Cargar 
    v-card
      v-card-title.headline Carga masiva de datos
      v-card-text
        v-container(grid-list-md) 
          v-radio-group.mt-0(row v-model='signo_de_separacion' label='Separador' )
            v-radio( value=',' label='Coma ( , )' )
            v-radio( value=';' label='Punto y coma ( ; )' )
          .custom-file.mb-4
            input#customFileLang.custom-file-input(type='file' lang='es' accept=".csv" @change="readFile")
            label.custom-file-label(for='customFileLang')  
          

          v-data-table.elevation-1( :headers="headers" :items="review")
            template( v-slot:item.actions="{item}" )
              v-btn( icon @click='review.splice(review.indexOf(item), 1)' )
                v-icon( small ) far fa-trash-alt

          
          v-btn( color='primary' type="input"  data-dismiss="modal" @click="saveCVS()")
            v-icon fa-save 
            span.ml-1 Guardar
      

</template>
<style lang="sass">
</style>
<script>
import {productsCollection} from '@/FirebaseConfig'
import {mapState} from 'vuex'
export default {
  data:()=>({
     review:[],
     inputCSV: null,
     dialog: false, 
      headers: [
      {
        text: 'Código',
        value: 'code',
      },
      {
        text: 'Cantidad',
        value: 'cantidad',
      },
      {
        text: '',
        value: 'actions',
      },

    ], 
    signo_de_separacion: ';'
  }),
  methods:{
    readFile: function(ev){
      const file = ev.target.files[0]
      const reader = new FileReader()
      reader.onload = e => {
        let data_in =  e.target.result
      
        let lines = data_in.split("\n")
        let result = []
        let headers = [
          'code',
          'cantidad',
        ]

        for(var i=1;i<lines.length;i++){
          if(lines[i]!=''){
            let obj = {};
            let currentline=lines[i].split(this.signo_de_separacion)

            for(let j=0;j<headers.length;j++){
              obj[headers[j]] = currentline[j]
            }
           if( obj.cantidad>0 ) result.push(obj);
          }
        }
        this.review = [...result]       
      }
      reader.readAsText(file)
    },
 
    async saveCVS(){
      await this.$store.dispatch('Inputs/massiveAdd', this.review )
    },

  },
  computed:{
    ...mapState({
      Entradas: state => state.Inputs
    })
  },
}
</script>
